<template>
  <BaseCompletePage
    :content="getCover"
    :hideSdnExternal="true"
    :showAllQuoteSummary="false"
    :cardTitle="'Your Rent Protection Insurance quote'"
    :showTotalPremiumIPT="showTotalPremiumIPT"
    insurancePremiumTitle="Rent Protection premium (ex IPT)"
    annualTitle="One off payment"
  />
</template>

<script>
import BaseCompletePage from "@/views/BaseCompletePage.vue";
import { mapGetters, mapState } from "vuex";
import {
  QUESTIONS_MODULE,
  APPLICATION_MODULE,
} from "@/store/types/module-types";
import { MONTHLY } from "@/constants/common.constants";

export default {
  name: "CompletePage",
  components: {
    BaseCompletePage,
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["getCover"]),
    ...mapState(APPLICATION_MODULE, ["questionMap"]),
    showTotalPremiumIPT() {
      return this.questionMap["PaymentFrequency"].Value === MONTHLY;
    },
  },
};
</script>
